// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_partttss {
  padding: 20px 30px;
}
.header_inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user_drop {
  display: flex;
  gap: 0.6rem;
  align-items: center;
  border: 1px solid #d4d3e0;
  padding: 0.6rem;
  border-radius: 3rem;
}
.user_drop_icon {
  position: relative;
}
.user_drop_icon > img {
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 50%;
}
.userdrop_name {
  font-size: 1rem;
  font-weight: 500;
  color: #6c6d72;
}
.user_badge {
  position: absolute;
  right: -4px;
  top: -4px;
  display: block;
  line-height: 1;
}
.prf_iconnn .dropdown-menu {
  width: 100%;
  border-radius: 0.8rem;
  padding: 0.8rem 0;
}
.prf_iconnn .dropdown-menu .dropdown-item {
  padding: 0.8rem;
  font-size: 1rem;
}
.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show > .btn-success.dropdown-toggle {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}

.modal_close h3 {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #000;
}

.modal_close .close_buuut {
  width: 25px;
  height: 25px;
  text-align: center;
  padding: 0px;
  border: 0px;
  background: #f00;
  position: absolute;
  right: -15px;
  top: -15px;
  line-height: 25px;
  border-radius: 100%;
}
.modal_close .close_buuut:after {
  content: "X";
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.footer_but {
  display: flex;
  justify-content: center;
  align-items: center;
}

.yesbut {
  padding: 0 30px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: 600;
  background: #0571b9;
  font-size: 18px;
  text-transform: uppercase;
  margin: 0 10px;
  border: 0px;
}

.nobut {
  padding: 0 30px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: 600;
  background: #f00;
  font-size: 18px;
  text-transform: uppercase;
  margin: 0 10px;
  border: 0px;
}
@media screen and (max-width: 767px) {
  .header_logo {
    max-width: 150px;
    width: 100%;
  }
  .header_logo img {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .header_partttss {
    padding: 10px 0;
  }
}

@media screen and (max-width: 420px) {
  .header_logo {
    max-width: 100px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/header/header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;;;EAGE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":[".header_partttss {\n  padding: 20px 30px;\n}\n.header_inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.user_drop {\n  display: flex;\n  gap: 0.6rem;\n  align-items: center;\n  border: 1px solid #d4d3e0;\n  padding: 0.6rem;\n  border-radius: 3rem;\n}\n.user_drop_icon {\n  position: relative;\n}\n.user_drop_icon > img {\n  width: 45px;\n  height: 45px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.userdrop_name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #6c6d72;\n}\n.user_badge {\n  position: absolute;\n  right: -4px;\n  top: -4px;\n  display: block;\n  line-height: 1;\n}\n.prf_iconnn .dropdown-menu {\n  width: 100%;\n  border-radius: 0.8rem;\n  padding: 0.8rem 0;\n}\n.prf_iconnn .dropdown-menu .dropdown-item {\n  padding: 0.8rem;\n  font-size: 1rem;\n}\n.btn-success:not(:disabled):not(.disabled).active,\n.btn-success:not(:disabled):not(.disabled):active,\n.show > .btn-success.dropdown-toggle {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.modal_close h3 {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #000;\n}\n\n.modal_close .close_buuut {\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  padding: 0px;\n  border: 0px;\n  background: #f00;\n  position: absolute;\n  right: -15px;\n  top: -15px;\n  line-height: 25px;\n  border-radius: 100%;\n}\n.modal_close .close_buuut:after {\n  content: \"X\";\n  color: #fff;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.footer_but {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.yesbut {\n  padding: 0 30px;\n  height: 40px;\n  line-height: 40px;\n  color: #fff;\n  font-weight: 600;\n  background: #0571b9;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin: 0 10px;\n  border: 0px;\n}\n\n.nobut {\n  padding: 0 30px;\n  height: 40px;\n  line-height: 40px;\n  color: #fff;\n  font-weight: 600;\n  background: #f00;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin: 0 10px;\n  border: 0px;\n}\n@media screen and (max-width: 767px) {\n  .header_logo {\n    max-width: 150px;\n    width: 100%;\n  }\n  .header_logo img {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .header_partttss {\n    padding: 10px 0;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .header_logo {\n    max-width: 100px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
